import {Directive, ElementRef, HostListener, NgZone, OnInit, Optional, Renderer2} from '@angular/core';
import {MatFormField} from '@angular/material/form-field';

@Directive({
    selector: '[appAutofill]',
    standalone: false
})
export class AutofillDirective implements OnInit {
    private elRef!: HTMLInputElement;
    private hasChangedToAuto = false;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private ngZone: NgZone,
        @Optional() private matFormField: MatFormField
    ) {
    }

    ngOnInit(): void {
        this.elRef = this.elementRef.nativeElement as HTMLInputElement;
        this.importantAppearance();
        if (this.elRef) {
            this.detectAutofill().then((isAutofilled): void => {
                if (isAutofilled) {
                    this.changeFloatLabel('always');
                }
            });
        }
    }

    @HostListener('focus')
    @HostListener('input')
    onUserInteraction(): void {
        if (!this.hasChangedToAuto) {
            this.changeFloatLabel('auto');
            this.hasChangedToAuto = true;
        }
    }

    private detectAutofill(): Promise<boolean> {
        return new Promise<boolean>((resolve): void => {
            const intervalId = setInterval((): void => {
                const isAutofilled: boolean = window.getComputedStyle(this.elRef, null).getPropertyValue('appearance') === 'menulist-button';

                if (isAutofilled) {
                    clearInterval(intervalId);
                    resolve(isAutofilled);
                }
            }, 100);
        });
    }

    private changeFloatLabel(value: 'auto' | 'always'): void {
        if (this.matFormField) {
            this.ngZone.run((): void => {
                this.matFormField.floatLabel = value;
            });
        }
    }

    private importantAppearance(): void {
        this.renderer.addClass(this.elRef, 'autofill-checker');
    }
}
